import React from 'react';
import { useParams } from 'react-router-dom';
import { Spin, Table } from 'antd';
import { ColumnProps } from 'antd/es/table';
import style from './style.module.scss';
import { Grant } from '../../stores/promotion-grant';
import { useAuthStore, usePromotionGrantStore } from '../../contexts/mobx';
import { Tag } from '../../components/tag';
import star from '../../icons/Icon_Coupons_Gagnants_1_1X.svg';
import { useNavigation } from '../../utils/use-navigation';

const columnsNormal: ColumnProps<Grant>[] = [
    {
        title: 'Id',
        dataIndex: 'id',
        key: 'id',
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
    },
    {
        title: 'Name',
        key: 'name',
        render: (_: unknown, record: Grant) =>
            `${record.client.firstName} ${record.client.lastName}`,
    },
    {
        title: 'Language',
        key: 'language',
        render: (_: unknown, record: Grant) => (
            <Tag variant={record.client.language === 'fr' ? 'blue' : 'magenta'}>
                {record.client.language}
            </Tag>
        ),
    },
    {
        title: 'Newsletter',
        key: 'newsletter',
        render: () => <Tag>No info yet</Tag>,
    },
    {
        title: 'Postal code',
        key: 'postalCode',
        dataIndex: 'postalCode',
    },
    {
        title: 'Phone number',
        key: 'phoneNumber',
        dataIndex: 'phoneNumber',
    },
    {
        title: 'Number of wins',
        key: 'numberOfWins',
        render: (_: unknown, record: Grant) => (
            <div>
                <img src={star} alt="star icon" />
                <span className={style.normal}>{record.cnt}</span>
            </div>
        ),
    },
];

export const PromotionGrantsPage = () => {
    const store = usePromotionGrantStore();
    const params = useParams<{ id: string }>();
    const [grants, setGrants] = React.useState<Grant[] | null>(null);
    const [isFetching, setIsFetching] = React.useState(false);
    const authStore = useAuthStore();
    const navigation = useNavigation();

    const { hasManagementAccess } = authStore;

    if (!hasManagementAccess) {
        navigation.goToHome();
    }

    const dataSourceNormal = grants?.map((x) => ({
        id: x.id,
        clientId: x.clientId,
        cnt: x.cnt,
        client: x.client,
    }));

    const fetchGrants = React.useCallback(() => {
        setIsFetching(true);
        store
            .fetchAllGrants(Number(params.id))
            .then(setGrants)
            .catch(console.log)
            .finally(() => setIsFetching(false));
    }, [params.id, store]);

    React.useEffect(() => {
        fetchGrants();
    }, [fetchGrants]);

    return (
        <div>
            {isFetching ? (
                <Spin />
            ) : (
                <Table<Grant>
                    rowKey="id"
                    columns={columnsNormal}
                    dataSource={dataSourceNormal}
                    pagination={false}
                />
            )}
        </div>
    );
};

PromotionGrantsPage.displayName = 'PromotionGrantsPage';
